module.exports = __webpack_public_path__ + "img/120.989fd4f4.jpg";